import { ACSS, P } from "@upsolve/ui";
import React from "react";
import styled from "styled-components";

import trackComponentAction from "../analytics/trackComponentAction";
import { CTATarget, getCTATrackingTarget, getCTAURL } from "../CTA/getCTAData";
import { MyUpsolveLink } from "../Links/MyUpsolveLink";

const trackingProps = {
  componentName: "UpsolveTextBio",
  componentVersion: "1",
};

const DEFAULT_DESCRIPTION: React.ReactNode = (
  <>
    <b>Upsolve is a nonprofit that helps you eliminate your debt with our free bankruptcy filing tool.</b>
    &nbsp;Think TurboTax for bankruptcy. You could be debt-free in as little as 4 months. Featured in Forbes 4x and
    funded by institutions like Harvard University — so we’ll never ask you for a credit card.
  </>
);
const DEFAULT_HYPERLINK_TEXT = "See if you qualify";

const UpsolveTextBio = (props: {
  wordCount?: number;
  ctaTarget?: CTATarget;
  trackingPageContext: Record<string, unknown>;
}) => {
  const { ctaTarget = CTATarget.SCREENER } = props;

  const ctaTargetToCopy: { [key in CTATarget]: { description: React.ReactNode; hyperlinkText: string } } = {
    [CTATarget.SCREENER]: {
      description: DEFAULT_DESCRIPTION,
      hyperlinkText: DEFAULT_HYPERLINK_TEXT,
    },
    [CTATarget.STUDENT_LOANS]: {
      description: DEFAULT_DESCRIPTION,
      hyperlinkText: DEFAULT_HYPERLINK_TEXT,
    },
    [CTATarget.DEBT_TRIAGE]: {
      description: DEFAULT_DESCRIPTION,
      hyperlinkText: DEFAULT_HYPERLINK_TEXT,
    },
  };
  const url = getCTAURL(ctaTarget);

  return (
    <StyledUpsolveTextBio>
      <P>
        {ctaTargetToCopy[ctaTarget].description}{" "}
        <MyUpsolveLink
          aria-busy="false"
          href={url}
          onClick={() => {
            trackComponentAction({
              ...trackingProps,
              actionId: `upsolveTextBio.${getCTATrackingTarget(ctaTarget || CTATarget.SCREENER)}`,
              actionMethod: "click",
            });
          }}
        >
          <u>
            {ctaTargetToCopy[ctaTarget].hyperlinkText}
            <span className="cta-arrow"> →</span>
          </u>
        </MyUpsolveLink>
      </P>
    </StyledUpsolveTextBio>
  );
};

const StyledUpsolveTextBio = styled.span`
  margin: 1em 0;

  label {
    font-size: 11px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.brand[500]};
  }

  p {
    margin: 0;
    font-size: 15px; /* desktop */
    line-height: 150%;
    color: ${(props) => props.theme.colors.gray[700]};
  }

  span {
    ${ACSS}
    &:hover {
      cursor: pointer;
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
    margin: 1em 0;

    p {
      font-size: 14px;
    }

    .cta-arrow {
      display: none;
    }
  }
`;

export default UpsolveTextBio;
